import { IndicatorElement } from '@mygpt/app/access/indicator/indicatorElement';
import { useLazyRef } from '@mygpt/app/utils';
import { createContext } from 'react';
import { createStore, StoreApi } from 'zustand';

export interface IndicatorState {
  opened: boolean;
  open: () => void;
  close: () => void;
  element: JSX.Element | null;
  setElement: (element: JSX.Element) => void;
}

export const IndicatorContext = createContext<StoreApi<IndicatorState> | null>(null);

interface Props {
  children: JSX.Element;
  element: JSX.Element;
}

export function IndicatorProvider({ children, element }: Props) {
  const storeRef = useLazyRef(() =>
    createStore<IndicatorState>((set) => ({
      opened: true,
      open: () => set({ opened: true }),
      close: () => set({ opened: false }),
      element: element,
      setElement: (element) => set({ element }),
    }))
  );

  return (
    <IndicatorContext.Provider value={storeRef.current}>
      <IndicatorElement />
      {children}
    </IndicatorContext.Provider>
  );
}
